(() => {
  if (window.VESofasReveal) {
    window.VESofasReveal.init(document);
    return;
  }

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let observer = null;

  function revealNow(elements) {
    elements.forEach((element) => {
      element.classList.add("ve-sofas-is-visible");
      element.removeAttribute("data-ve-reveal-bound");
    });
  }

  function ensureObserver() {
    if (observer || prefersReducedMotion.matches || !("IntersectionObserver" in window)) {
      return observer;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("ve-sofas-is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.12 }
    );

    return observer;
  }

  function init(root = document) {
    const elements = Array.from(root.querySelectorAll("[data-ve-reveal]:not([data-ve-reveal-bound])"));

    if (!elements.length) {
      return;
    }

    if (prefersReducedMotion.matches || !("IntersectionObserver" in window)) {
      revealNow(elements);
      return;
    }

    document.documentElement.classList.add("is-ve-sofas-reveal-ready");
    const activeObserver = ensureObserver();

    elements.forEach((element) => {
      element.setAttribute("data-ve-reveal-bound", "true");
      activeObserver.observe(element);
    });
  }

  window.VESofasReveal = { init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
